export default {"src":"/_next/static/media/High-RiskPregnancy.0ea3a411.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};